var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,on:{"click":_vm.toggleRouter}},[_c('el-tooltip',{attrs:{"open-delay":1500,"content":"Построение маршрута","placement":"bottom"}},[_c('r-icon',{attrs:{"name":"route","size":24,"color-type":_vm.$route.name === 'odd-router' ? 'accent-primary' : ''}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }